import { BaseEntity } from '../../../models';
import { Representante } from '../../pessoa/representante';

export class RegiaoRepresentante implements BaseEntity {
    readonly id: number;
    idRegiao: number;
    idRepresentante: number;
    representante: Representante;
}
